import React, { useState } from 'react'
import { Backdrop, Box, CardMedia, styled, useTheme, Button } from '@mui/material'
import FileUpload from "react-mui-fileuploader"
import API, { baseUrl } from '../../../config/SocketApi';
import { useTranslation } from 'react-i18next';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { addPath } from '../../../features/tabs/tabsSlice';
import { useDispatch } from 'react-redux';
import ExternalPdfViewer from '../helpers/PdfViewer';

const Board = ({ panel }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageUrl, setImageUrl] = useState()
    const theme = useTheme();
    const { t } = useTranslation();

    const handleFileUploadError = (error) => {
        console.log("the error is ", error)
    }

    const handleFilesChange = (files) => {

        if (!files.length) return;
        let formData = new FormData()
        files.forEach((file) => formData.append("file", file))
        setIsLoading(true)
        API.post('api/board/addFile', formData).then(res => {
            setIsLoading(false);
            dispatch(addPath({ path: baseUrl + "public/files/" + res.data.file.filename, id: panel.id }))
        }).catch(err => {
            console.log("the error is ", err)
            setIsLoading(false);
        })
    };

    const ViewerBox = styled(Box)({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'white',
        alignItems: 'center',
        '& .sc-fLcnxK,.sc-ftTHYK': {
            display: 'none'
        },
        '& #header-bar,#pdf-controls, #pdf-page-info, #WACStatusBarContainer': {
            display: 'none'
        },
        '& #react-doc-viewer': {
            color: theme.palette.text.default,
            backgroundColor: 'white',
            overflow: 'visible !important'
        }, '& #proxy-renderer': {
            overflow: 'visible !important'
        },
        overflowY: 'auto',
        overflow: 'scroll-y',
    })

    function isPdfUrl(url) {
        return url.toLowerCase().endsWith('.pdf');
    }
    return (
        <Box sx={{ display: panel.active ? 'block' : "none", position: 'relative', height: '100%' }}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CardMedia component="img"
                    image="./assets/loading.gif"
                    sx={{ width: '8rem' }}
                />
            </Backdrop>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={imageLoaded}
            >
                {imageUrl && <Box><Button onClick={() => setImageLoaded(false)} >close</Button><img src={imageUrl} /></Box>}

            </Backdrop>
            {!panel.path && !isLoading && (<ViewerBox sx={{ backgroundColor: theme.palette.background.default }} >
                <FileUpload
                    acceptedType={[
                        'image/*', // for all image formats
                        'application/pdf', // for PDF files
                        'application/msword', // for Word files (.doc)
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // for Word files (.docx)
                        'application/vnd.ms-excel', // for Excel files (.xls)
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // for Excel files (.xlsx)
                        'application/vnd.ms-powerpoint', // for PowerPoint files (.ppt)
                        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // for PowerPoint files (.pptx)
                        // 'text/plain' // for text files (.txt)
                    ]}
                    multiFile={false}
                    onFilesChange={(f) => handleFilesChange(f)}
                    onError={handleFileUploadError}
                    onContextReady={(context) => { }}
                    dir={theme.direction}
                    title={t("uploaderheadertext")}
                    leftLabel={t("or")}
                    rightLabel={t("selectfiles")}
                    buttonLabel={t("clickhere")}
                    header={`[${t("draganddrop")}]`}
                />
            </ViewerBox>)
            }
            {(isLoading || imageLoaded) && <ViewerBox >
            </ViewerBox>}

            {!isLoading && panel.path && !imageLoaded && !isPdfUrl(panel.path) && <ViewerBox
                id={panel.path} >
                <DocViewer
                    pluginRenderers={DocViewerRenderers}
                    documents={[{ uri: panel.path }]}
                    initialActiveDocument={{ uri: panel.path }}
                    config={{
                        header: {
                            disableHeader: true,
                        },
                        pdfVerticalScrollByDefault: true, // false as default
                    }}

                />
            </ViewerBox>}
            {!isLoading && panel.path && !imageLoaded && isPdfUrl(panel.path)
                &&
                <ViewerBox id={panel.path} >
                    <ExternalPdfViewer fileUrl={panel.path} />
                </ViewerBox>}
        </Box>

    )
}

export default Board